import type { SessionExportBundle } from '@gitlab-lsp/workflow-api';

export const EXPORT_HOST_DETAIL_WARNING =
  'This bundle describes the machine it ran on: tool output can contain usernames, paths and environment detail. Review it before sharing.';

export const EXPORT_UNANCHORED_PATHS_WARNING =
  'It also contains absolute paths naming your home directory. Only paths under the directory you export from are anchored, so run the export from the directory the session ran in.';

export function exportBudgetWarning(bundle: SessionExportBundle): string | undefined {
  const { budget, summary } = bundle;
  if (!budget) return undefined;

  if (budget.exceeded) {
    return `This bundle is larger than the ${budget.maxBytes}-byte limit: the session identifier alone exceeds it, so trimming the transcript could not bring it down.`;
  }

  if (budget.omittedEntryCount > 0) {
    const total = summary.entryCount + budget.omittedEntryCount;
    return `Only ${summary.entryCount} of ${total} entries fit the ${budget.maxBytes}-byte limit, so the oldest were dropped. This transcript is a partial record of the session.`;
  }

  return undefined;
}

// The shapes doctor/sanitize.ts redacts. Anchoring replaces paths under the
// export's own root, so whatever matches here escaped it.
const HOME_PATH_PATTERN = /(?:\/Users\/|\/home\/|[A-Za-z]:\\Users\\)[^/\\\s"]+/;

export function hasUnanchoredHostPaths(bundle: SessionExportBundle): boolean {
  // JSON doubles the Windows separator; collapse it so one pattern covers both.
  return HOME_PATH_PATTERN.test(JSON.stringify(bundle).replace(/\\\\/g, '\\'));
}
